import React from "react";
import "../styles/Footer.css";
import logoNoir from '@public/images/logo-noir.png';
import Coordonates from "./Coordonates";

const Footer = () => {
  return (
    <nav className="footer">
      <div className='navigationFooter'>
        <h1>Cabinet Isabelle PIVET</h1>
        <img
          src="/images/logo-noir.png"
          alt='Carte de Visite Isabelle Pivet'
          style={{
            width: 120,
            height: 120,
            marginTop: 20
          }}
        />
      </div>
      <div className='navigationFooter'>
        <h1>Expertise :</h1>
        <p>
          Maître Pivet vous accompagne dans vos démarches de défense et de protection de vos droits.
          Elle est l'atout qui vous consultera, vous défendra et vous soutiendra lors de votre passage au tribunal.
        </p>
      </div>
      <div className='navigationFooter'>
        <h1>&Agrave; propos :</h1>
        <a href="/contact">
          <span>Contact</span>
        </a>
        {/* <a href="/personal">
          <span>Données personnelles</span>
        </a>
        <a href="/mentions">
          <span>Mentions légales</span>
        </a> */}
      </div>
      <div className='navigationFooter'>
        <Coordonates />
      </div>
    </nav>
  );
};

export default Footer;
